import { useEffect, useState } from "react";
import { Button, Form, Image, Modal } from "react-bootstrap";
import { MappingForm } from "./CustomForm";

export const AddModal = props => {
    const { isShowM, setShowM, mTitle, structure, onSubmit } = props;

    const [data, setData] = useState({});

    useEffect(() => {
        if (isShowM && structure?.length) {
            const initialData = {};
            structure.forEach(({ field, init }) => {
                initialData[field] = init;
            });
            setData(initialData);
        }
    }, [isShowM, structure]);

    const onClose = () => {
        setShowM(false);
    }

    return (
        <Modal show={isShowM} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{mTitle || "Add Data"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={e => onSubmit(e, data)}>
                    <MappingForm structure={structure} data={data} setData={setData} />
                    <div className="text-end mt-3">
                        <Button variant="primary" type="submit">Submit</Button>
                    </div>
                </Form>

            </Modal.Body>
        </Modal>
    )
}

export const EditImageModal = props => {
    const { isShowM, setShowM, mTitle, structure, onSubmit, img } = props;

    const [data, setData] = useState({});

    // useEffect(() => {
    //     console.log(data)
    // }, [data])

    useEffect(() => {
        if (isShowM && structure?.length) {
            const initialData = {};
            structure.forEach(({ field, init }) => {
                initialData[field] = init;
            });
            setData(initialData);
        }
    }, [isShowM, structure]);

    const onClose = () => {
        setShowM(false);
    }

    return (
        <Modal show={isShowM} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{mTitle || "Image"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={e => onSubmit(e, data)}>
                    <MappingForm structure={structure} data={data} setData={setData} />
                    <Image src={img} fluid alt="" />
                    <div className="text-end mt-3">
                        <Button variant="primary" type="submit">Submit</Button>
                    </div>
                </Form>

            </Modal.Body>
        </Modal>
    )
}

export const EditModal = props => {
    const { isShowM, setShowM, mTitle, structure, existingData, onSubmit, size } = props;

    const [data, setData] = useState({});

    useEffect(() => {
        if (isShowM && existingData && structure?.length) {
            const initialData = {};
            structure.forEach(({ field }) => {
                initialData[field] = existingData[field] !== undefined ? existingData[field] : "";
            });
            setData({...initialData, id: existingData.id});
        }
    }, [isShowM, existingData, structure]);

    const onClose = () => {
        setShowM(false);
    };

    return (
        <Modal show={isShowM} onHide={onClose} centered size={size || "md"}>
            <Modal.Header closeButton>
                <Modal.Title>{mTitle || "Edit Data"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={e => onSubmit(e, data)}>
                    <MappingForm structure={structure} data={data} setData={setData} />
                    <div className="text-end mt-3">
                        <Button variant="warning" type="submit">Submit</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export const ImageContainerModal = props => {
    const { isShowM, setShowM, data, url } = props;

    const onClose = () => {
        setShowM(false);
    };

    return (
        <Modal show={isShowM} onHide={onClose} centered size='xl'>
            <Modal.Header closeButton>
                <Modal.Title>{data?.title || "Image"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Modal.Body className="d-flex justify-content-center">
                    <Image src={url} fluid alt="" />
                </Modal.Body>
            </Modal.Body>
        </Modal>
    );
}